import { Flex } from '@lokalise/louis';

import { styled } from '@app/styled';
import { color, spacing, typography } from '@app/theme';

export const Container = styled(Flex)`
    height: 80%;
    width: 100%;
    margin-top: 50px;
    gap: ${spacing(2)};
`;

export const Heading = styled.h4`
    ${typography('custom.heading1')};
`;

export const SubHeading = styled.span`
    ${typography('custom.heading3')};
    color: ${color('custom.content.disabled')};
    font-weight: 400;
`;
